import { render, staticRenderFns } from "./ChildSupport.vue?vue&type=template&id=7e21d936&scoped=true&"
import script from "./ChildSupport.vue?vue&type=script&lang=js&"
export * from "./ChildSupport.vue?vue&type=script&lang=js&"
import style0 from "./ChildSupport.vue?vue&type=style&index=0&id=7e21d936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e21d936",
  null
  
)

export default component.exports